(function ($) {
  Drupal.behaviors.ehContentFormatterV2 = {
    attach: function (context, settings) {
      $('.eh-content-formatter', context).each(function () {
        var thisFormatter = $(this);
        var liItems = thisFormatter.find('.slides li');
        var max = Math.max.apply(Math, liItems.map(function () {
	  return $(this).height();
        }));

        liItems.height(max + 'px');
      });
    }
  };
})(jQuery);
